import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { baseButtonToken } from 'src/theme/components/button/base-button-token';
import { basePrimitive } from 'src/theme/primitive/base-primitive';
import { semanticBaseDesignTokens } from 'src/theme/semantic/base-semantic';
import { baseDatepickerToken } from './components/datepicker/base-datepicker-token';
import { basePopoverToken } from './components/popover/base-popover-token';
import { baseDatatableToken } from './components/datatable/base-datatable-token';
import { baseIconFieldToken } from './components/iconfield/iconfield-token';
import { baseBadgeToken } from './components/badge/base-badge-token';
import { baseOverlayBadgeToken } from './components/overlay-badge/base-overlay-badge-token';
import { baseDividerToken } from './components/divider/base-divider-token';
import { dialogToken } from 'src/theme/components/dialog/dialog-token';
import { baseSplitterToken } from './components/splitter/base-splitter-token';
import { baseTooltipToken } from './components/tooltip/base-tooltip-token';
import { baseMultiselectToken } from './components/multiselect/base-multiselect-token';
import { baseCheckboxToken } from './components/checkbox/base-checkbox-token';
import { baseToggleswitchToken } from './components/toggleswitch/base-toggleswitch-token';
import { baseTreetableToken } from './components/treetable/base-treetable-token';
import { baseRadioToken } from './components/radio/base-radio-token';
import { baseSelectButtonToken } from 'src/theme/components/selectbutton/base-selectbutton-token';
import { baseToggleButtonToken } from 'src/theme/components/togglebutton/base-togglebutton-token';
import { baseSkeletonToken } from './components/skeleton/base-skeleton-token';
import { baseVirtualScrollerToken } from './components/virtual-scroller/base-virtual-scroller-token';
import { baseToastToken } from './components/toast/base-toast-token';
import { baseProgressbarToken } from './components/progressbar/base-progressbar-token';
import { baseSpeedDialToken } from './components/speeddial/base-speeddial-token';
import { baseSelectToken } from 'src/theme/components/select/base-select-token';
import { baseContextMenuToken } from './components/contextmenu/base-contextmenu-token';

export const gcBaseThemePreset = definePreset(Aura, {
  primitive: basePrimitive,
  semantic: semanticBaseDesignTokens,
  components: {
    button: baseButtonToken,
    badge: baseBadgeToken,
    overlaybadge: baseOverlayBadgeToken,
    divider: baseDividerToken,
    datepicker: baseDatepickerToken,
    popover: basePopoverToken,
    datatable: baseDatatableToken,
    iconfield: baseIconFieldToken,
    dialog: dialogToken,
    splitter: baseSplitterToken,
    tooltip: baseTooltipToken,
    multiselect: baseMultiselectToken,
    checkbox: baseCheckboxToken,
    toggleswitch: baseToggleswitchToken,
    treetable: baseTreetableToken,
    radiobutton: baseRadioToken,
    selectbutton: baseSelectButtonToken,
    select: baseSelectToken,
    togglebutton: baseToggleButtonToken,
    skeleton: baseSkeletonToken,
    virtualscroller: baseVirtualScrollerToken,
    toast: baseToastToken,
    progressbar: baseProgressbarToken,
    speeddial: baseSpeedDialToken,
    contextmenu: baseContextMenuToken,
  },
});
